import { useEffect, useState } from "react";
import Loading from "../components/ui/Loading";
import { useTranslation } from "react-i18next";

import { AppDispatch, RootState } from "../store/indexRedux";
import { useSelector } from "react-redux";
import { toast, Flip, Bounce } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchUserCompany, resetCompanyState } from "../store/companySlice";
import { getSessionFromCookie } from "../components/utils/cognito";
import { CompanyApiResponse } from "../types/companyTypes";
import { NavLink, useNavigate } from "react-router-dom";
import { checkCompanyExists, createCompany, searchCompany, sendAccessRequest, type CompanyApiError } from "../api/company";
import { CountrySelector } from "../components/ui/CompanySelector";
import { CompanySearchInput } from "../components/company/search/CompanySearchInput";
import { CompanySearchResults } from "../components/company/search/CompanySearchResults";
import { CompanyForm } from "../components/company/form/CompanyForm";
import { PageLayout } from "../components/layout/PageLayout";
import { BillingForm } from "../components/company/form/BillingForm";
import { WarningToast } from "../components/ui/toastResponds/WarningToast";
import { ErrorToast } from "../components/ui/toastResponds/ErrorToast";
import { SuccessToast } from "../components/ui/toastResponds/SuccessToast";
import { PendingToast } from "../components/ui/toastResponds/PendingToast";

interface ApiError {
  response?: {
    status: number;
    data?: {
      message?: string;
    };
  };
  message: string;
}

interface SearchResultCompany {
  companyName: string | null;
  vatNumber: string | null;
  addressLine1: string | null;
  addressLine2?: string | null;
  addressNumber: string | null;
  postalCode: string | null;
  city: string | null; // allow null to match API
  country: string | null;
  contact?: {
    email?: string | null;
    web?: string | null;
    telephone?: string | null;
  };
  metadata?: {
    number?: number;
    numberText?: string | null;
    formattedNumber?: string | null;
    startDate?: string | null;
    type?: string | null;
    legalForm?: string | null;
    juridicalSituation?: string | null;
    NACECode?: string | null;
  };
}

interface companySelected {
  companyName: string | null;
  vatNumber: string | null;
  addressLine1: string | null;
  addressLine2?: string | null;
  addressNumber: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
  contact?: {
    email?: string | null;
    web?: string | null;
    telephone?: string | null;
  };
  metadata?: {
    number?: number | null;
    numberText?: string | null;
    formattedNumber?: string | null;
    startDate?: string | null;
    type?: string | null;
    legalForm?: string | null;
    juridicalSituation?: string | null;
    NACECode?: string | null;
  };
}

function AddCompanyPage() {
  const userInfo = useSelector((state: RootState) => state.user.user); // Access userInfo from Redux store
  // console.log(userInfo);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { t } = useTranslation("AddCompany");

  const session = getSessionFromCookie();
  const token = session?.getAccessToken().getJwtToken();

  const [registrationNumberDisplay, setRegistrationNumberDisplay] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [validationError, setValidationError] = useState("");
  // const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  // const [selectedCountry, setSelectedCountry] = useState('Belgium');
  const [companyExists, setCompanyExists] = useState(false);
  const [existingCompanyName, setExistingCompanyName] = useState("");
  const [accessRequestMessage, setAccessRequestMessage] = useState("");
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [alreadyLinked, setAlreadyLinked] = useState(false);

  const [currentStep, setCurrentStep] = useState<"company" | "billing">("company");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isNewUser = params.get("newUser") === "true";
    setShowBanner(isNewUser);
  }, []);

  // console.log(showBanner);

  // console.log(registrationNumber);
  console.log(error);
  // NEW: hold multiple search results
  const [searchResults, setSearchResults] = useState<SearchResultCompany[]>([]);
  // If you'd like to show/hide the dropdown manually:
  const [showResults, setShowResults] = useState(false);

  const [companyData, setCompanyData] = useState({
    companyName: "",
    vatNumber: "",
    addressLine1: "",
    addressLine2: "",
    addressNumber: "",
    addressNumber2: "",
    postalCode: "",
    city: "",
    country: "",
    email: "",
    web: "",
    telephone: "",
    metadataNumber: "",
    metadataNumberText: "",
    metadataFormattedNumber: "",
    metadataStartDate: "",
    metadataType: "",
    metadataLegalForm: "",
    metadataJuridicalSituation: "",
    metadataNACECode: "",
    user_id: userInfo?.id || "", // Add the user_id field as optional
    billingEmail: "",
    billingAddressStreet: "",
    billingAddressNumber: "",
    billingAddressZip: "",
    billingAddressCity: "",
    billingAddressCountry: "",
    invoicingCycle: "",
    iban: "",
  });

  const handleCountrySelect = (country: string) => {
    setCompanyData((prev) => ({
      ...prev,
      country,
    }));
  };

  const parseRegistrationInput = (input: string) => {
    let cleaned = input.replace(/\s|\./g, "").toUpperCase();

    if (cleaned.startsWith("BE")) {
      cleaned = cleaned.slice(2);
    }

    const originalDigits = cleaned;

    if (cleaned.startsWith("0")) {
      cleaned = cleaned.slice(1);
    }
    const kboNumber = cleaned;

    let vatFormatted = "";
    if (originalDigits.length >= 10) {
      const first4 = originalDigits.slice(0, 4);
      const next3 = originalDigits.slice(4, 7);
      const last3 = originalDigits.slice(7, 10);
      vatFormatted = `BE ${first4}.${next3}.${last3}`;
    }

    return {
      originalDigits,
      kboNumber,
      vatFormatted,
    };
  };

  const handleRegistrationNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = e.target.value;

    setRegistrationNumberDisplay(userInput);

    // Only parse as VAT number if input looks like a VAT number (contains digits)
    const hasDigits = /\d/.test(userInput);
    const looksLikeVAT = /^(BE\s?)?[\d\s.]+$/.test(userInput.trim());

    if (hasDigits && looksLikeVAT) {
      // Only parse if it looks like a VAT number
      const { originalDigits, kboNumber, vatFormatted } = parseRegistrationInput(userInput);
      setRegistrationNumber(originalDigits);

      setCompanyData((prev) => ({
        ...prev,
        metadataNumber: kboNumber,
        vatNumber: vatFormatted,
      }));
    } else {
      // If it's likely a company name, don't modify VAT fields
      setRegistrationNumber("");
      // Don't update VAT-related fields when searching by company name
    }

    // Reset search results when user changes input
    setSearchResults([]);
    setShowResults(false);
  };
  const handleVatNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const userVatInput = e.target.value;

    const { originalDigits, kboNumber, vatFormatted } = parseRegistrationInput(userVatInput);
    setRegistrationNumberDisplay(vatFormatted || userVatInput);
    setRegistrationNumber(originalDigits);

    setCompanyData((prev) => ({
      ...prev,
      vatNumber: vatFormatted || userVatInput,
      metadataNumber: kboNumber,
      metadataFormattedNumber: vatFormatted,
    }));

    if (kboNumber.length > 0 && kboNumber.length < 9) {
      setValidationError("Registration number must be at least 9 characters long (excluding BE and leading zero).");
    } else {
      setValidationError("");
    }

    // setSuccessMessage('');
    // Reset any previous results
    setSearchResults([]);
    setShowResults(false);
  };

  // NEW: click a search result to load it into the form
  const handleSelectCompany = (company: companySelected) => {
    function clean(val: string | null | undefined) {
      return val === null || val === "null" ? "" : val || "";
    }

    setCompanyData({
      companyName: clean(company.companyName),
      vatNumber: clean(company.vatNumber),
      addressLine1: clean(company.addressLine1),
      addressLine2: clean(company.addressLine2),
      addressNumber: clean(company.addressNumber),
      postalCode: clean(company.postalCode),
      city: clean(company.city),
      country: clean(company.country),
      email: clean(company.contact?.email),
      web: clean(company.contact?.web),
      telephone: clean(company.contact?.telephone),
      metadataNumber: company.metadata?.number?.toString() || "",
      metadataNumberText: clean(company.metadata?.numberText),
      metadataFormattedNumber: clean(company.metadata?.formattedNumber),
      metadataStartDate: clean(company.metadata?.startDate),
      metadataType: clean(company.metadata?.type),
      metadataLegalForm: clean(company.metadata?.legalForm),
      metadataJuridicalSituation: clean(company.metadata?.juridicalSituation),
      metadataNACECode: clean(company.metadata?.NACECode),
      addressNumber2: "",
      user_id: "",
      billingEmail: clean(company.contact?.email),
      billingAddressStreet: clean(company.addressLine1),
      billingAddressNumber: clean(company.addressNumber),
      billingAddressZip: clean(company.postalCode),
      billingAddressCity: clean(company.city),
      billingAddressCountry: clean(company.country),
      invoicingCycle: "Monthly",
      iban: "",
    });

    setIsEditable(true);
    // Hide the dropdown
    setSearchResults([]);
    setShowResults(false);
    setCompanyExists(false);
    // If you want to also update the input with the name or number:
    setRegistrationNumberDisplay(company.companyName || "");
  };

  const handleLookupCompany = async () => {
    setError("");
    setIsEditable(false);

    const cleanedTerm = registrationNumberDisplay.replace(/\./g, "").replace(/^BE/i, "").trim();

    if (!token) {
      toast.error(t("noTokenFound"));
      return;
    }

    try {
      const response: CompanyApiResponse = await toast.promise(
        searchCompany(cleanedTerm, token),
        {
          pending: {
            render: () => <PendingToast title={t("searchTitle")} message={t("lookingUptheCompany")} />,
          },
          success: {
            render: () => <SuccessToast title={t("successTitle")} message={t("successCompanyFound")} />,
          },
          error: {
            render: () => <ErrorToast title={t("errorTitle")} message={t("companyNotFound")} />,
          },
        },
        {
          position: "bottom-right",
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          icon: false,
          transition: Flip,
          style: {
            width: "400px",
            maxWidth: "800px",
          },
        }
      );

      // If successful, update state with results
      // console.log(response);
      setSearchResults(response.companies);
      setShowResults(true);
      setError("");
    } catch (err) {
      console.error(err);

      // Reset form inputs if there is an error
      setRegistrationNumber("");
      setRegistrationNumberDisplay("");
      setCompanyData({
        companyName: "",
        vatNumber: "",
        addressLine1: "",
        addressLine2: "",
        addressNumber: "",
        postalCode: "",
        city: "",
        country: "",
        email: "",
        web: "",
        telephone: "",
        metadataNumber: "",
        metadataNumberText: "",
        metadataFormattedNumber: "",
        metadataStartDate: "",
        metadataType: "",
        metadataLegalForm: "",
        metadataJuridicalSituation: "",
        metadataNACECode: "",
        addressNumber2: "",
        user_id: "",
        billingEmail: "",
        billingAddressStreet: "",
        billingAddressNumber: "",
        billingAddressZip: "",
        billingAddressCity: "",
        billingAddressCountry: "",
        invoicingCycle: "",
        iban: "",
      });

      setIsEditable(true);
      setSearchResults([]);
      setShowResults(false);
    } finally {
      setLoading(false);
    }
  };

  const handleAddCompany = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!userInfo?.id) {
      setError(t("noTokenFound"));
      toast.error(<ErrorToast title={t("errorTitle")} message={t("noTokenFound")} />, {
        position: "bottom-right",
        autoClose: 7000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
      return;
    }

    setError("");
    if (!token) {
      toast.error(t("noTokenFound"));
      return;
    }

    try {
      const trimmedPayload = {
        kbo_number: (companyData.metadataNumber || "").trim(),
        company_legal_name: (companyData.companyName || "").trim(),
        company_vat: (companyData.vatNumber || "").trim(),
        company_founded: (companyData.metadataStartDate || "").trim(),
        company_nace_code: (companyData.metadataNACECode || "").trim(),
        company_legal_form: (companyData.metadataLegalForm || "").trim(),
        company_email: (companyData.email || "").trim(),
        company_phone: (companyData.telephone || "").trim(),
        company_website: (companyData.web || "").trim(),
        company_address_street: (companyData.addressLine1 || "").trim(),
        company_address_number: (companyData.addressNumber || "").trim(),
        company_address_zip: (companyData.postalCode || "").trim(),
        company_address_city: (companyData.city || "").trim(),
        company_address_country: (companyData.country || "").trim(),
        user_id: userInfo.id.toString(),
        billing_email: (companyData.billingEmail || "").trim(),
        billing_address_street: (companyData.billingAddressStreet || "").trim(),
        billing_address_number: (companyData.billingAddressNumber || "").trim(),
        billing_address_zip: (companyData.billingAddressZip || "").trim(),
        billing_address_city: (companyData.billingAddressCity || "").trim(),
        billing_address_country: (companyData.billingAddressCountry || "").trim(),
        invoicing_cycle: (companyData.invoicingCycle || "").trim(),
        iban: (companyData.iban || "").trim(),
      };

      const response: CompanyApiResponse = await toast.promise(
        createCompany(trimmedPayload, token),
        {
          pending: {
            render: () => <PendingToast title={t("addingCompanyTitle")} message={t("addingCompany")} />,
          },
          success: {
            render: () => <SuccessToast title={t("successTitle")} message={t("companyAdded")} />,
          },
          error: {
            render: ({ data }: { data: CompanyApiError }) => {
              if (data?.response?.status === 409) {
                return <WarningToast title={t("companyExistTitle")} message={t("companyExists")} />;
              }

              return <ErrorToast title={t("errorTitle")} message={t("companyNotAdded")} />;
            },
          },
        },
        {
          position: "bottom-right",
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          icon: false,
          transition: Bounce,
          style: {
            width: "400px",
            maxWidth: "800px",
          },
        }
      );

      // console.log('response from adding company ', response);
      // Reset form fields after success
      setRegistrationNumber("");
      setRegistrationNumberDisplay("");
      setCompanyData({
        companyName: "",
        vatNumber: "",
        addressLine1: "",
        addressLine2: "",
        postalCode: "",
        city: "",
        country: "",
        email: "",
        web: "",
        telephone: "",
        metadataNumber: "",
        metadataNumberText: "",
        metadataFormattedNumber: "",
        metadataStartDate: "",
        metadataType: "",
        metadataLegalForm: "",
        metadataJuridicalSituation: "",
        metadataNACECode: "",
        addressNumber: "",
        addressNumber2: "",
        user_id: "",
        billingEmail: "",
        billingAddressStreet: "",
        billingAddressNumber: "",
        billingAddressZip: "",
        billingAddressCity: "",
        billingAddressCountry: "",
        invoicingCycle: "",
        iban: "",
      });

      // Automatically select the newly added company and redirect to overview
      const newCompanyId = response.company_id;
      // console.log('response ', newCompanyId); // Assuming the response contains the new company's ID
      // console.log('New company ID:', newCompanyId);
      dispatch(resetCompanyState());
      localStorage.setItem("selectedCompanyId", newCompanyId.toString());
      const fetchResult = await dispatch(fetchUserCompany({ company_id: newCompanyId, token }));
      console.log("Fetch result:", fetchResult);
      if (fetchResult.meta.requestStatus === "fulfilled") {
        navigate("/overview", { replace: true });
        window.location.reload();
      } else {
        console.error("Failed to fetch user company");
        toast.error("Failed to fetch company details");
      }
    } catch (err) {
      setCompanyExists(true);
      setExistingCompanyName(companyData.companyName);

      console.log(err);
      console.error("An unexpected error occurred.");
    }
  };

  console.log(registrationNumber);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;

    if (name === "vatNumber" && e.target instanceof HTMLInputElement) {
      handleVatNumberChange(e as React.ChangeEvent<HTMLInputElement>);
    } else {
      setCompanyData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  // useEffect(() => {
  //   const init = async () => {
  //     if (location.pathname === '/overview') {
  //       // Force a reload of the page when we reach /overview
  //       window.location.reload();
  //     }
  //   };

  //   init();
  // }, [location.pathname]);

  const handleRequestAccess = async () => {
    if (!token) {
      toast.error(<ErrorToast title={t("errorTitle")} message={t("noTokenFound")} />, {
        position: "bottom-right",
        autoClose: 7000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        icon: false,
        transition: Bounce,
        style: {
          width: "400px",
          maxWidth: "800px",
        },
      });
      return;
    }

    if (!accessRequestMessage.trim()) {
      toast.error(<ErrorToast title={t("errorTitle")} message={t("pleaseEnterMessage")} />, {
        position: "bottom-right",
        autoClose: 7000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        icon: false,
        transition: Bounce,
        style: {
          width: "400px",
          maxWidth: "800px",
        },
      });

      return;
    }

    setIsRequestLoading(true);
    try {
      await toast.promise(
        sendAccessRequest(
          {
            companyName: existingCompanyName,
            companyVat: companyData.vatNumber,
            message: accessRequestMessage,
            kbo_number: companyData.metadataNumber,
          },
          token
        ),
        {
          pending: {
            render: () => <PendingToast title={t("sendingTitle")} message={t("sendingRequest")} />,
          },
          success: {
            render: () => <SuccessToast title={t("successTitle")} message={t("accesReuquestSent")} />,
          },
          error: {
            render: () => <ErrorToast title={t("errorTitle")} message={t("failedToSend")} />,
          },
        },
        {
          position: "bottom-right",
          autoClose: 7000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          icon: false,
          transition: Bounce,
          style: {
            width: "400px",
            maxWidth: "800px",
          },
        }
      );
      setAccessRequestMessage("");
      setRequestSent(true);
    } catch (err: unknown) {
      const error = err as ApiError;
      console.error("Failed to send access request:", error);
      console.log("Full error object:", error.response);
      if (error?.response?.status === 409) {
        setAlreadyLinked(true);
      }
    } finally {
      setIsRequestLoading(false);
    }
  };

  // const handleProceedToBilling = () => {
  //   setCompanyData((prev) => ({
  //     ...prev,
  //     billingEmail: prev.billingEmail || prev.email,
  //     billingAddressStreet: prev.billingAddressStreet || prev.addressLine1,
  //     billingAddressNumber: prev.billingAddressNumber || prev.addressNumber,
  //     billingAddressZip: prev.billingAddressZip || prev.postalCode,
  //     billingAddressCity: prev.billingAddressCity || prev.city,
  //     billingAddressCountry: prev.billingAddressCountry || prev.country,
  //     invoicingCycle: prev.invoicingCycle || 'Monthly',
  //   }));
  //   setCurrentStep('billing');
  // };
  const handleProceedToBilling = async () => {
    if (!companyData.vatNumber || !/^BE\s?\d{4}\.\d{3}\.\d{3}$/.test(companyData.vatNumber)) {
      toast.error(<ErrorToast title={t("errorTitle")} message={t("invalidVatNumber")} />);
      return;
    }

    if (!token) {
      toast.error(<ErrorToast title={t("errorTitle")} message={t("noTokenFound")} />);
      return;
    }

    if (!companyData.metadataNumber) {
      toast.error(<ErrorToast title={t("errorTitle")} message={t("vatNumberRequired")} />);
      return;
    }

    try {
      console.log("Checking company with number:", companyData.metadataNumber);
      const response = await checkCompanyExists(companyData.metadataNumber, token);
      console.log("Company check response:", response);

      if (response.exists) {
        console.log("Company exists, setting state...");
        setCompanyExists(true);
        setExistingCompanyName(response.company.companyName || companyData.companyName);
        return;
      }

      // Company doesn't exist, proceed to billing
      console.log("Company does not exist, proceeding to billing...");
      setCompanyData((prev) => ({
        ...prev,
        billingEmail: prev.billingEmail || prev.email,
        billingAddressStreet: prev.billingAddressStreet || prev.addressLine1,
        billingAddressNumber: prev.billingAddressNumber || prev.addressNumber,
        billingAddressZip: prev.billingAddressZip || prev.postalCode,
        billingAddressCity: prev.billingAddressCity || prev.city,
        billingAddressCountry: prev.billingAddressCountry || prev.country,
        invoicingCycle: prev.invoicingCycle || "Monthly",
      }));
      setCurrentStep("billing");
    } catch (err) {
      console.error("Error checking company existence:", err);
      toast.error(<ErrorToast title={t("errorTitle")} message={t("errorCheckingCompany")} />);
    }
  };

  const handleBackToCompany = () => {
    setCurrentStep("company");
  };

  return (
    <div className="mb-24">
      <PageLayout title={t("addCompanyTitle")} description={t("addCompanyDesc")}>
        {currentStep === "company" && (
          <>
            <NavLink to="/" className="flex items-center gap-2 text-primary-600 hover:text-primary-700 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              {t("back")}
            </NavLink>
          </>
        )}

        {/* Country Selector */}
        {currentStep === "company" && (
          <div>
            <CountrySelector onCountrySelect={handleCountrySelect} />
          </div>
        )}

        <div className="p-16 bg-white text-primary-600 flex flex-col gap-10 relative  text-sm">
          {loading && (
            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
              <Loading />
            </div>
          )}

          {/* {successMessage && <p className='text-green-500'>{successMessage}</p>} */}
          {currentStep === "company" && (
            <div>
              <div className="relative">
                <CompanySearchInput
                  registrationNumberDisplay={registrationNumberDisplay}
                  validationError={validationError}
                  loading={loading}
                  onSearchChange={handleRegistrationNumberChange}
                  onLookupClick={handleLookupCompany}
                />
                <CompanySearchResults results={searchResults} show={showResults} onSelect={handleSelectCompany} />
              </div>
            </div>
          )}

          {companyExists ? (
            <div className=" p-6 border border-primary-100 bg-gray-100 rounded-lg">
              {alreadyLinked ? (
                <div className="text-center py-8">
                  <h3 className="mt-4 text-lg font-semibold text-primary-600">{t("youAreAlreadyLinked")}</h3>
                </div>
              ) : requestSent ? (
                <div className="text-center py-8">
                  <svg
                    className="mx-auto h-12 w-12 text-[#838300]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <h3 className="mt-4 text-lg font-semibold text-primary-600">{t("thankYou")}</h3>
                  <p className="mt-2 text-sm text-primary-400">
                    {t("requestSentMessage", { companyName: existingCompanyName })}
                  </p>
                </div>
              ) : (
                <>
                  <h3 className="text-sm font-semibold">
                    {t("existingCompanyAccount", { companyName: existingCompanyName })}
                  </h3>
                  <p className="text-primary-500 font-sm mb-6">{t("useFormBellow")}</p>
                  <div className="flex flex-col gap-4">
                    <div>
                      <textarea
                        value={accessRequestMessage}
                        onChange={(e) => setAccessRequestMessage(e.target.value)}
                        className="w-full border rounded-md p-3"
                        rows={4}
                        placeholder={t("pleaseProvide")}
                        disabled={isRequestLoading}
                      />
                    </div>
                    <div className="flex justify-start">
                      <button
                        onClick={handleRequestAccess}
                        disabled={isRequestLoading || !accessRequestMessage.trim()}
                        className="py-2 px-4 font-sm rounded-md bg-primary-600 text-white disabled:opacity-50"
                      >
                        {isRequestLoading ? t("sending") : t("requestAccess")}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <>
              {currentStep === "company" ? (
                <CompanyForm
                  companyData={companyData}
                  isEditable={isEditable}
                  loading={loading}
                  onInputChange={handleInputChange}
                  onProceedToBilling={handleProceedToBilling}
                />
              ) : (
                <BillingForm
                  companyData={companyData}
                  onInputChange={handleInputChange}
                  onBack={handleBackToCompany}
                  onSubmit={handleAddCompany}
                />
              )}
            </>
          )}
        </div>
        {showBanner && (
          <div className="max-w-7xl mx-auto my-10">
            <div className="p-4 md:p-6 border border-primary-50 rounded-lg bg-primary-50/50 shadow-sm">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="space-y-1.5">
                  <h3 className="text-lg font-semibold text-primary-600">{t("dontWantToCreate")}</h3>
                  <p className="text-sm text-primary-600">{t("youCanMenage")}</p>
                </div>
                <a
                  href={import.meta.env.VITE_LANDING}
                  className="inline-flex items-center px-4 py-2.5 text-sm 
                 bg-primary-600 text-white rounded-lg hover:bg-primary-700 
                 transition-all duration-200 font-semibold ease-in-out transform
                 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                >
                  <span>{t("goToConsole")}</span>
                  <svg
                    className="ml-2 w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        )}
      </PageLayout>
    </div>
  );
}

export default AddCompanyPage;
